import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { openNotification } from '../../../../helpers/notification';
import { activateConsultant, deactivateConsultant } from '../../../../helpers/api';

export default function ActivateConsultant({ open, onClose, consultant }) {
  const [saving, setSaving] = useState(false);

  const handleActive = async () => {
    setSaving(true);
    try {
      const res = await activateConsultant(consultant?.userId);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        onClose();
        openNotification({
          type: 'success',
          title: status?.desc,
        });
      }
    } catch (error) {
      const errmsg = error?.data?.result?.desc;
      openNotification({
        type: 'error',
        title: errmsg,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Activate Consultant
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent>
        <Alert severity="info" icon={false}>
          You are about to Activate {consultant?.fullName}
        </Alert>
        <br />
        <Typography>{`Are you sure you want to do this?`}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pt: 2, pb: 3 }}>
        <Button
          type="button"
          variant="contained"
          color="primary"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          sx={{ textTransform: 'none', borderRadius: 20 }}
          onClick={handleActive}
        >
          Yes, Activate
        </Button>
      </DialogActions>
    </Dialog>
  );
}
